<template lang="pug">
  .welcome-container
    .welcome-sprite
      div(:class="`w${frame.toFixed(0)}`")
      //img(:class="`welcome-${45-Math.abs(frame%92-46)+1}`" alt="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWoAAAFVAQMAAAD8OjfYAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAACZJREFUeNrtwYEAAAAAw6D5U9/gBFUBAAAAAAAAAAAAAAAAAADANT6bAAHOxOcTAAAAAElFTkSuQmCC")
</template>

<script>
  import Raf from 'src/helpers/Raf'
  import { mapState, mapMutations } from 'vuex'
  export default {
    name: "WelcomeSprite",
    props:{
      progress: {
        default: 0
      }
    },
    data(){
      return {
        frame: 1,
        frameRate: 1000/20,
        interval: null,

      }
    },
    computed:{

      //frame(){
      //  return Math.floor(this.progress*30)%15+1
      //}
    },
    mounted(){
      //this.interval = setInterval(this.update, this.frameRate)
      this.anime()
    },
    methods:{
      update(){
        this.frame++
      },

      anime(){
        let tl = new TimelineMax({ onComplete: () => {
            this.$emit('complete')
          }
        })
        this.tl = tl

        //console.log(this.$el.getBoundingClientRect(), this.$el.offsetHeight)
        //console.log(444, this.$refs.btns.childNodes)
        tl.add('start')
          .to(
            this,
            2.5,
            {
              frame: 82,
              ease: SteppedEase.config(81)
            },
            `start+=0.2`
          )
          .to(
            this,
            2.5,
            {
              frame: 1,
              ease: SteppedEase.config(81)
            },
            `start+=2.2`
          )
      }

    },
    beforeDestroy(){
      //clearInterval(this.interval)
    }
  }
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.welcome-container
  +full()
  display: flex
  align-items: center
  justify-content: center
  .welcome-sprite
    width: 3rem
    height: 2.941rem
    margin-left: 0.1rem
    //background: #e15125
    img
      //width: 100%
      display: block




.w1, .w2, .w3, .w4, .w5, .w6, .w7, .w8, .w9, .w10, .w11, .w12, .w13, .w14, .w15, .w16, .w17, .w18, .w19, .w20, .w21, .w22, .w23, .w24, .w25, .w26, .w27, .w28, .w29, .w30, .w31, .w32, .w33, .w34, .w35, .w36, .w37, .w38, .w39, .w40, .w41, .w42, .w43, .w44, .w45, .w46, .w47, .w48, .w49, .w50, .w51, .w52, .w53, .w54, .w55, .w56, .w57, .w58, .w59, .w60, .w61, .w62, .w63, .w64, .w65, .w66, .w67, .w68, .w69, .w70, .w71, .w72, .w73, .w74, .w75, .w76, .w77, .w78, .w79, .w80, .w81, .w82
  display: inline-block
  overflow: hidden
  background-repeat: no-repeat
  background-image: url('~assets/ui/welcomeSprite3.png')

.w1
  width: 100%
  height: 100%
  background-position: 0.0535619% 0.0534616%
  background-size: 1131.49%

.w2
  width: 100%
  height: 100%
  background-position: 9.80182% 0.0534616%
  background-size: 1131.49%

.w3
  width: 100%
  height: 100%
  background-position: 19.5501% 0.0534616%
  background-size: 1131.49%

.w4
  width: 100%
  height: 100%
  background-position: 29.2983% 0.0534616%
  background-size: 1131.49%

.w5
  width: 100%
  height: 100%
  background-position: 39.0466% 0.0534616%
  background-size: 1131.49%

.w6
  width: 100%
  height: 100%
  background-position: 48.7949% 0.0534616%
  background-size: 1131.49%

.w7
  width: 100%
  height: 100%
  background-position: 58.5431% 0.0534616%
  background-size: 1131.49%

.w8
  width: 100%
  height: 100%
  background-position: 68.2914% 0.0534616%
  background-size: 1131.49%

.w9
  width: 100%
  height: 100%
  background-position: 78.0396% 0.0534616%
  background-size: 1131.49%

.w10
  width: 100%
  height: 100%
  background-position: 87.7879% 0.0534616%
  background-size: 1131.49%

.w11
  width: 100%
  height: 100%
  background-position: 97.5362% 0.0534616%
  background-size: 1131.49%

.w12
  width: 100%
  height: 100%
  background-position: 0.0535619% 9.59636%
  background-size: 1131.49%

.w13
  width: 100%
  height: 100%
  background-position: 9.80182% 9.59636%
  background-size: 1131.49%

.w14
  width: 100%
  height: 100%
  background-position: 19.5501% 9.59636%
  background-size: 1131.49%

.w15
  width: 100%
  height: 100%
  background-position: 29.2983% 9.59636%
  background-size: 1131.49%

.w16
  width: 100%
  height: 100%
  background-position: 39.0466% 9.59636%
  background-size: 1131.49%

.w17
  width: 100%
  height: 100%
  background-position: 48.7949% 9.59636%
  background-size: 1131.49%

.w18
  width: 100%
  height: 100%
  background-position: 58.5431% 9.59636%
  background-size: 1131.49%

.w19
  width: 100%
  height: 100%
  background-position: 68.2914% 9.59636%
  background-size: 1131.49%

.w20
  width: 100%
  height: 100%
  background-position: 78.0396% 9.59636%
  background-size: 1131.49%

.w21
  width: 100%
  height: 100%
  background-position: 87.7879% 9.59636%
  background-size: 1131.49%

.w22
  width: 100%
  height: 100%
  background-position: 97.5362% 9.59636%
  background-size: 1131.49%

.w23
  width: 100%
  height: 100%
  background-position: 0.0535619% 19.1393%
  background-size: 1131.49%

.w24
  width: 100%
  height: 100%
  background-position: 9.80182% 19.1393%
  background-size: 1131.49%

.w25
  width: 100%
  height: 100%
  background-position: 19.5501% 19.1393%
  background-size: 1131.49%

.w26
  width: 100%
  height: 100%
  background-position: 29.2983% 19.1393%
  background-size: 1131.49%

.w27
  width: 100%
  height: 100%
  background-position: 48.7949% 19.1393%
  background-size: 1131.49%

.w28
  width: 100%
  height: 100%
  background-position: 39.0466% 19.1393%
  background-size: 1131.49%

.w29
  width: 100%
  height: 100%
  background-position: 58.5431% 19.1393%
  background-size: 1131.49%

.w30
  width: 100%
  height: 100%
  background-position: 78.0396% 19.1393%
  background-size: 1131.49%

.w31
  width: 100%
  height: 100%
  background-position: 68.2914% 19.1393%
  background-size: 1131.49%

.w32
  width: 100%
  height: 100%
  background-position: 87.7879% 19.1393%
  background-size: 1131.49%

.w33
  width: 100%
  height: 100%
  background-position: 97.5362% 19.1393%
  background-size: 1131.49%

.w34
  width: 100%
  height: 100%
  background-position: 0.0535619% 28.6822%
  background-size: 1131.49%

.w35
  width: 100%
  height: 100%
  background-position: 9.80182% 28.6822%
  background-size: 1131.49%

.w36
  width: 100%
  height: 100%
  background-position: 19.5501% 28.6822%
  background-size: 1131.49%

.w37
  width: 100%
  height: 100%
  background-position: 29.2983% 28.6822%
  background-size: 1131.49%

.w38
  width: 100%
  height: 100%
  background-position: 39.0466% 28.6822%
  background-size: 1131.49%

.w39
  width: 100%
  height: 100%
  background-position: 48.7949% 28.6822%
  background-size: 1131.49%

.w40
  width: 100%
  height: 100%
  background-position: 58.5431% 28.6822%
  background-size: 1131.49%

.w41
  width: 100%
  height: 100%
  background-position: 68.2914% 28.6822%
  background-size: 1131.49%

.w42
  width: 100%
  height: 100%
  background-position: 78.0396% 28.6822%
  background-size: 1131.49%

.w43
  width: 100%
  height: 100%
  background-position: 97.5362% 28.6822%
  background-size: 1131.49%

.w44
  width: 100%
  height: 100%
  background-position: 87.7879% 28.6822%
  background-size: 1131.49%

.w45
  width: 100%
  height: 100%
  background-position: 0.0535619% 38.2251%
  background-size: 1131.49%

.w46
  width: 100%
  height: 100%
  background-position: 19.5501% 38.2251%
  background-size: 1131.49%

.w47
  width: 100%
  height: 100%
  background-position: 9.80182% 38.2251%
  background-size: 1131.49%

.w48
  width: 100%
  height: 100%
  background-position: 48.7949% 38.2251%
  background-size: 1131.49%

.w49
  width: 100%
  height: 100%
  background-position: 29.2983% 38.2251%
  background-size: 1131.49%

.w50
  width: 100%
  height: 100%
  background-position: 39.0466% 38.2251%
  background-size: 1131.49%

.w51
  width: 100%
  height: 100%
  background-position: 58.5431% 38.2251%
  background-size: 1131.49%

.w52
  width: 100%
  height: 100%
  background-position: 68.2914% 38.2251%
  background-size: 1131.49%

.w53
  width: 100%
  height: 100%
  background-position: 78.0396% 38.2251%
  background-size: 1131.49%

.w54
  width: 100%
  height: 100%
  background-position: 87.7879% 38.2251%
  background-size: 1131.49%

.w55
  width: 100%
  height: 100%
  background-position: 9.80182% 47.7680%
  background-size: 1131.49%

.w56
  width: 100%
  height: 100%
  background-position: 19.5501% 47.7680%
  background-size: 1131.49%

.w57
  width: 100%
  height: 100%
  background-position: 97.5362% 38.2251%
  background-size: 1131.49%

.w58
  width: 100%
  height: 100%
  background-position: 0.0535619% 47.7680%
  background-size: 1131.49%

.w59
  width: 100%
  height: 100%
  background-position: 29.2983% 47.7680%
  background-size: 1131.49%

.w60
  width: 100%
  height: 100%
  background-position: 39.0466% 47.7680%
  background-size: 1131.49%

.w61
  width: 100%
  height: 100%
  background-position: 48.7949% 47.7680%
  background-size: 1131.49%

.w62
  width: 100%
  height: 100%
  background-position: 58.5431% 47.7680%
  background-size: 1131.49%

.w63
  width: 100%
  height: 100%
  background-position: 68.2914% 47.7680%
  background-size: 1131.49%

.w64
  width: 100%
  height: 100%
  background-position: 78.0396% 47.7680%
  background-size: 1131.49%

.w65
  width: 100%
  height: 100%
  background-position: 87.7879% 47.7680%
  background-size: 1131.49%

.w66
  width: 100%
  height: 100%
  background-position: 9.80182% 57.3109%
  background-size: 1131.49%

.w67
  width: 100%
  height: 100%
  background-position: 97.5362% 47.7680%
  background-size: 1131.49%

.w68
  width: 100%
  height: 100%
  background-position: 0.0535619% 57.3109%
  background-size: 1131.49%

.w69
  width: 100%
  height: 100%
  background-position: 29.2983% 57.3109%
  background-size: 1131.49%

.w70
  width: 100%
  height: 100%
  background-position: 19.5501% 57.3109%
  background-size: 1131.49%

.w71
  width: 100%
  height: 100%
  background-position: 68.2914% 57.3109%
  background-size: 1131.49%

.w72
  width: 100%
  height: 100%
  background-position: 48.7949% 57.3109%
  background-size: 1131.49%

.w73
  width: 100%
  height: 100%
  background-position: 39.0466% 57.3109%
  background-size: 1131.49%

.w74
  width: 100%
  height: 100%
  background-position: 58.5431% 57.3109%
  background-size: 1131.49%

.w75
  width: 100%
  height: 100%
  background-position: 78.0396% 57.3109%
  background-size: 1131.49%

.w76
  width: 100%
  height: 100%
  background-position: 97.5362% 57.3109%
  background-size: 1131.49%

.w77
  width: 100%
  height: 100%
  background-position: 87.7879% 57.3109%
  background-size: 1131.49%

.w78
  width: 100%
  height: 100%
  background-position: 0.0535619% 66.8538%
  background-size: 1131.49%

.w79
  width: 100%
  height: 100%
  background-position: 9.80182% 66.8538%
  background-size: 1131.49%

.w80
  width: 100%
  height: 100%
  background-position: 19.5501% 66.8538%
  background-size: 1131.49%

.w81
  width: 100%
  height: 100%
  background-position: 29.2983% 66.8538%
  background-size: 1131.49%

.w82
  width: 100%
  height: 100%
  background-position: 39.0466% 66.8538%
  background-size: 1131.49%


</style>